import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment'

// TODO Sacar esto a una configuración por idiomas
moment.updateLocale('es', {
    relativeTime: {
        ss: '%d seg.',
        m: 'un min.',
        mm: '%d min.',
        hh: '%d h.',
        dd: '%d d.'
    },
    longDateFormat: {
        L: 'DD/MM/YYYY',
        llll: 'DD/MM/YYYY HH:mm'
    }
})
moment.updateLocale('pt', {
    relativeTime: {
        ss: '%d seg.',
        m: 'un min.',
        mm: '%d min.',
        hh: '%d h.',
        dd: '%d d.'
    },
    longDateFormat: {
        L: 'DD/MM/YYYY',
        llll: 'DD/MM/YYYY HH:mm'
    }
})
moment.updateLocale('en', {
    relativeTime: {
        ss: '%d sec.',
        m: 'one min.',
        mm: '%d min.',
        hh: '%d h.',
        dd: '%d d.'
    },
    longDateFormat: {
        L: 'MM/DD/YYYY',
        llll: 'MM/DD/YYYY HH:mm'
    }
})

Vue.use(VueMoment)
